import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient/apiClient'

export const useGetTrustpilotRating = () => {
  const res = useQuery(['trustpilot'], async () => {
    const response = await baseClient.get<{
      score: { stars: number }
      number_of_reviews: { total: number }
    }>(`/trustpilot`)
    return response.data
  })

  return res
}
